import axios from "axios";
import { useToast } from "@/comn/hooks";
import { useState } from "react";

export const useMyInfoChg = () => {
    const { showToast } = useToast();
    const [findIdForm, setFindIdForm] = useState({
        usrId: "",
        usrNm: "",
        cstmOfcrNo: "",
        usrEmlAddr: "",
        isLcm: false,
    });

    const handleSubmitFindId = async (event: any) => {
        event.preventDefault();

        const { usrNm, usrEmlAddr, cstmOfcrNo, isLcm } = findIdForm;

        try {
            const caseMap: any = {
                tanoga: `/api/v1/osci/mypage/myinfochg/findOgaUsrId/${usrNm}/${usrEmlAddr}`,
            };

            const base = process.env.REACT_APP_API_OSCI;
            const path = caseMap[process.env.REACT_APP_SYSTEM_GROUP + (isLcm ? "LCM" : "")];

            const response = await axios.get(base + path);
            const { findId } = response.data;
            setFindIdForm((prev) => ({ ...prev, usrId: findId.content }));
        } catch (error: any) {
            console.log(error);
            showToast({ content: error.response?.data?.errorMessage || "error", type: "error" });
        }
    };

    return { findIdForm, setFindIdForm, handleSubmitFindId };
};
